"use client";

import "./App.css";
import { BrowserRouter } from "react-router-dom";
import GlobalModal from "./components/layout/GlobalModal";
import AppRoutes from "./routes";
import ScrollToTop from "./scrollToTop";
import { AuthProvider } from "./components/auth/AuthContext";
import RoleBootstrap from "./components/auth/RoleBootstrap";
import TalentRedirection from "./components/shared/talentRedirection"; // adjust path
import { isDeprecatedAuthRoute } from "./components/shared/utils/logoutRedirect"; // adjust path

function App() {
  const shouldRedirect =
    typeof window !== "undefined" && isDeprecatedAuthRoute(window.location);

  // ✅ Only /signin and /signup on old hosts will hit this
  if (shouldRedirect) {
    return <TalentRedirection mode="notfound" autoRedirectMs={10000} />;
  }
  return (
    <AuthProvider>
      <RoleBootstrap>
        <BrowserRouter basename="/console">
          <ScrollToTop />
          <GlobalModal />
          <AppRoutes />
        </BrowserRouter>
      </RoleBootstrap>
    </AuthProvider>
  );
}

export default App;
